import { Box, Divider, styled, Typography } from '@mui/material';
import { TranslatedEvent } from '../../shift-detail-head/shift-info-button/types';

type LogsListProps = {
  logs: TranslatedEvent[];
};

export const LogsList = ({ logs }: LogsListProps) => {
  return (
    <StyledLogsList>
      {logs.map((log) => (
        <Box key={log.definition}>
          <Typography>{log.definition}</Typography>
          {log.properties?.map((property, j) => (
            <Typography variant="body2" key={j}>
              {property.name}: {property.value}
            </Typography>
          ))}
          <StyledDivider />
        </Box>
      ))}
    </StyledLogsList>
  );
};

const StyledLogsList = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
}));

const StyledDivider = styled(Divider)(({ theme }) => ({
  margin: `${theme.spacing(4)} 0`,
  height: '1px',
}));
